import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Sparkles, Mountain, Loader2 } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";

const err = (e) => formatApiError(e?.response?.data?.detail) || e.message;

export function AiFeedback({ playbook }) {
  const { t, i18n } = useTranslation();
  const [text, setText] = useState(playbook.last_feedback || "");
  const [busy, setBusy] = useState(false);
  const run = async () => {
    setBusy(true);
    try { const { data } = await api.post(`/playbooks/${playbook.id}/ai-feedback`, null, { params: { lang: i18n.language } }); setText(data.feedback); }
    catch (e) { toast.error(err(e)); } finally { setBusy(false); }
  };
  return (
    <div data-testid="playbook-ai-feedback">
      <Button onClick={run} disabled={busy} variant="outline" data-testid="playbook-ai-feedback-btn" className="gap-2">
        {busy ? <Loader2 size={14} className="animate-spin" /> : <Sparkles size={14} className="text-amber-500" />}{t("playbooks.askProfessor")}
      </Button>
      {text && <div className="mt-3 rounded-xl bg-slate-50 border border-slate-200 p-4 text-sm text-slate-700 whitespace-pre-wrap leading-relaxed" data-testid="playbook-ai-feedback-text">{text.replace(/\*\*/g, "").replace(/^#{1,6}\s*/gm, "").replace(/^\s*[-*]\s+/gm, "• ")}</div>}
    </div>
  );
}

export function ApplyClimb({ playbook }) {
  const { t } = useTranslation();
  const [plans, setPlans] = useState([]);
  const [pid, setPid] = useState("");
  useEffect(() => { api.get("/climb/plans").then((r) => setPlans(r.data?.plans || r.data || [])).catch(() => {}); }, []);
  const apply = async () => {
    try {
      const { data } = await api.post(`/playbooks/${playbook.id}/apply-climb`, { plan_id: pid });
      toast.success(t("playbooks.climbApplied", { wr: Math.round(data.win_rate * 100), rr: data.reward_multiple }));
    } catch (e) { toast.error(err(e)); }
  };
  if (!plans.length) return <p className="text-xs text-slate-500">{t("playbooks.noClimb")}</p>;
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="playbook-apply-climb">
      <select value={pid} onChange={(e) => setPid(e.target.value)} data-testid="playbook-climb-select" className="h-9 rounded-md border border-slate-300 bg-white px-3 text-sm">
        <option value="">{t("playbooks.pickClimb")}</option>
        {plans.map((p) => <option key={p.id} value={p.id}>{p.name}</option>)}
      </select>
      <Button onClick={apply} disabled={!pid} variant="outline" data-testid="playbook-apply-climb-btn" className="gap-2 h-9"><Mountain size={14} />{t("playbooks.applyClimb")}</Button>
    </div>
  );
}
